export const HashViews = {
  player: 'player',
};
